/* Source: /home/ubuntu/libredraw/frontend/editor/ToolRail.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { MousePointer2, Hand, Square, Spline, PenLine, Type, StickyNote, MessageSquare, Image as ImageIcon, Sparkles, Eraser, Frame, Table, Lock, LockOpen } from "lucide-react";
import { cn } from "../../lib/utils.js";
function Tool(props) {
  const {active, title, onClick, icon} = props;
  return __jacJsx("button", {"title": title, "onClick": onClick, "className": cn("flex size-9 items-center justify-center rounded-lg transition-colors", (active ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:bg-accent hover:text-foreground"))}, [icon]);
}
const tool = Tool;
function ToolRail(props) {
  const {activeTool: activeTool = "select", onSelect: onSelect = null, onAskAI: onAskAI = null, toolLocked: toolLocked = false, onToggleLock: onToggleLock = null} = props;
  let pick = t => {
    if (onSelect) {
      onSelect(t);
    }
  };
  return __jacJsx("div", {"data-testid": "toolrail", "className": "absolute left-3 top-1/2 z-20 flex -translate-y-1/2 flex-col gap-0.5 rounded-2xl border border-border bg-card p-1.5 shadow-panel"}, [__jacJsx("button", {"title": (toolLocked ? "Keep tool active  Q (on)" : "Keep tool active  Q - place several shapes in a row"), "aria-label": "Keep selected tool active", "aria-pressed": toolLocked, "data-testid": "tool-lock", "onClick": _e => {
    if (onToggleLock) {
      onToggleLock(null);
    }
  }, "className": cn("flex size-9 items-center justify-center rounded-lg transition-colors", (toolLocked ? "bg-primary text-primary-foreground shadow-sm" : "text-muted-foreground hover:bg-accent hover:text-foreground"))}, [(toolLocked ? __jacJsx(Lock, {"size": 16}, []) : __jacJsx(LockOpen, {"size": 16}, []))]), __jacJsx("div", {"className": "my-1 h-px bg-border"}, []), tool({active: (activeTool === "select"), title: "Select  V", onClick: _e => {
    pick("select");
  }, icon: __jacJsx(MousePointer2, {"size": 18}, [])}), tool({active: (activeTool === "pan"), title: "Hand  H", onClick: _e => {
    pick("pan");
  }, icon: __jacJsx(Hand, {"size": 18}, [])}), __jacJsx("div", {"className": "my-1 h-px bg-border"}, []), tool({active: (activeTool === "shape"), title: "Shape  R", onClick: _e => {
    pick("shape");
  }, icon: __jacJsx(Square, {"size": 18}, [])}), tool({active: (activeTool === "connector"), title: "Connector  C", onClick: _e => {
    pick("connector");
  }, icon: __jacJsx(Spline, {"size": 18}, [])}), tool({active: (activeTool === "pen"), title: "Draw freehand  P", onClick: _e => {
    pick("pen");
  }, icon: __jacJsx(PenLine, {"size": 18}, [])}), tool({active: (activeTool === "text"), title: "Text  T", onClick: _e => {
    pick("text");
  }, icon: __jacJsx(Type, {"size": 18}, [])}), tool({active: (activeTool === "sticky"), title: "Sticky note  S", onClick: _e => {
    pick("sticky");
  }, icon: __jacJsx(StickyNote, {"size": 18}, [])}), tool({active: (activeTool === "image"), title: "Image", onClick: _e => {
    pick("image");
  }, icon: __jacJsx(ImageIcon, {"size": 18}, [])}), tool({active: (activeTool === "frame"), title: "Frame", onClick: _e => {
    pick("frame");
  }, icon: __jacJsx(Frame, {"size": 18}, [])}), tool({active: (activeTool === "table"), title: "Table", onClick: _e => {
    pick("table");
  }, icon: __jacJsx(Table, {"size": 18}, [])}), tool({active: (activeTool === "eraser"), title: "Eraser  E", onClick: _e => {
    pick("eraser");
  }, icon: __jacJsx(Eraser, {"size": 18}, [])}), __jacJsx("div", {"className": "my-1 h-px bg-border"}, []), tool({active: (activeTool === "comment"), title: "Comment  M", onClick: _e => {
    pick("comment");
  }, icon: __jacJsx(MessageSquare, {"size": 18}, [])}), tool({active: false, title: "Ask AI", onClick: _e => {
    if (onAskAI) {
      onAskAI(null);
    }
  }, icon: __jacJsx(Sparkles, {"size": 18}, [])})]);
}
/*jac:refresh-boundary*/;
export {ToolRail};
//# sourceMappingURL=ToolRail.js.map
